import { queryClient } from '@/services/graphql/queryClient';

export const invalidateQueries = (keys: any) => {
  keys.forEach((key: any) => queryClient.invalidateQueries(key));
};

export const refetchQueries = (keys: any) => {
  keys.forEach((key: any) => queryClient.refetchQueries(key));
};
